<template src="./clientTabsMenu.html"></template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { Menu } from '../../../../models/Menu';
    import { LastViewedClients } from '../../../../models/Clients';
    import { CLIENT_TABS } from '../clientTabs';

    interface ComponentModel {
        tabs: Menu[];
    }

    export default defineComponent({
        name: 'ClientTabsMenu',
        props: {
            clientId: {
                type: [Number, String] as PropType<number | string>,
                default: null
            },
            activeTab: {
                type: String,
                default: ''
            },
            badges: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['tab-click'],
        data(): ComponentModel {
            return {
                tabs: [...CLIENT_TABS]
            };
        },
        computed: {
            activeTabItem(): Menu {
                return this.tabs.find(t => t.url === this.activeTab) ?? this.tabs[0];
            },
            backButton(): LastViewedClients | null {
                if (!this.clientId) return null;
                const clients: LastViewedClients[] = this.$store.getters.getLastViewedClients;
                const first = clients[0];
                // eslint-disable-next-line eqeqeq
                if (!first || first.id != this.clientId) return null;
                return first;
            }
        },
        methods: {
            onTabClick(tab: Menu): void {
                if (!this.clientId) return;
                this.$router.push(`/client/${this.clientId}/${tab.url}`);
                this.$emit('tab-click', tab);
            },
            clickOnBackButton(): void {
                if (!this.backButton?.buttonPath) return;

                if (this.backButton.buttonPath === '-1') {
                    if (this.$router.options?.history?.state?.back == null) return;
                    this.$router.go(-1);
                    return;
                }

                this.$router.push(this.backButton.buttonPath);
            }
        }
    });
</script>

<style scoped>
    .back_button_wrapper {
        display: flex;
    }

    .button_back {
        padding: 8px 24px;
        min-width: 107px;
        margin-bottom: 12px;
        border-radius: 12px;
        background-color: #eaebec;
        border: none;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .button_back span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .back_button_img {
        margin-right: 7px;
        margin-top: 1px;
        margin-left: -10px;
    }
</style>
